<template>
  <v-form ref="form">
    <v-row dense>
      <v-col cols="4">
        <v-select
          v-model="action.section"
          :items="signatureItems"
          :rules="rules.section"
          dense
          outlined
          :label="$t('commons.section')"
        />
      </v-col>

      <v-col cols="4">
        <v-select
          :clearable="clearable"
          v-model="action.assigned_user"
          :items="users"
          :rules="rules.assigned_user"
          dense
          outlined
          item-text="email"
          item-value="id"
          :label="$t('commons.intended_for')"
        />
      </v-col>
      <v-col cols="4">
        <v-text-field
          v-model="action.external_email"
          :rules="rules.external_email"
          clearable
          dense
          outlined
          :label="$t('commons.send_to_externes')"
        />
      </v-col>
    </v-row>
    <v-row class="pb-4 pr-4 d-flex align-center justify-end">
      <template v-if="saving">
        <v-progress-circular
          indeterminate
          size="20"
          color="primary"
        ></v-progress-circular>
      </template>
      <avs-saveButton
        v-else
        :disabled="isSaved || isSign || isClosed"
        @click="handleSave"
      />
    </v-row>
  </v-form>
</template>

<script>
import { required } from "@/utils/validator"
import TeamService from "@/services/TeamService"
import PcqDsiService from "@/services/PcqDsiService"
import { STATUS_ITEMS, STATUS_ITEMS_DISABLED, SIGNATURES_ITEMS } from "@/utils/consts"
import { isInspector } from "@/utils/middleware"

export default {
  name: "PcqAction",
  props: {
    value: {
      type: Object,
      required: true
    },
    clearable: {
      type: Boolean,
      default: true
    },
    isSaved: {
      type: Boolean,
      default: false
    },
    pcq: {
      type: Object,
      required: true
    },
    pcqLocked: {
      type: Boolean,
      required: false,
      default: false
    },
    projectId: {
      type: String,
      required: true
    }
  },
  created() {
    this.fetchUser()
  },
  data() {
    return {
      action: { ...this.value },
      rules: {
        endDate: [required],
        pcq: [required],
        section: [required],
        status: [required],
        external_email: [
          v => !this.action.assigned_user || !v || "Un seul champ doit être renseigné"
        ],
        assigned_user: [
          v => !this.action.external_email || !v || "Un seul champ doit être renseigné"
        ]
      },
      users: [],
      saving: false,
      isClosed: false,
      isSign: false
    }
  },
  computed: {
    statusItems() {
      return isInspector(this.projectRole) ? STATUS_ITEMS : STATUS_ITEMS_DISABLED
    },
    signatureItems() {
      return SIGNATURES_ITEMS
    },
    projectRole() {
      return this.$store.state.app.project.role
    }
  },
  methods: {
    async fetchUser() {
      const response = await TeamService.getTeam(this, this.projectId)
      this.users = response
    },
    async updateAction() {
      this.saving = true
      this.action.lang = this.$i18n.locale
      return PcqDsiService.updateAction(this.action.id, this.action)
        .then(response => {
          this.$emit("update", response)
          this.send(
            this.$t("messages.success.updated", { entity: this.$t("commons.action") }),
            "success"
          )
          this.saving = false
          if (this.action.status == "Closed") {
            this.isClosed = true
          }
        })
        .catch(err => {
          if (err.response && err.response.status === 403) {
            this.$store.commit("app/message", {
              msg: this.$t("messages.error.permission_denied"),
              color: "error"
            })
          } else {
            this.$emit("error", err)
          }
        })
    },
    async createAction() {
      this.saving = true
      this.action.lang = this.$i18n.locale
      return PcqDsiService.createAction(this.pcq.id, this.action)
        .then(response => {
          this.$emit("update", response)
          this.send(
            this.$t("messages.success.saved", { entity: this.$t("commons.signature") }),
            "success"
          )
          this.saving = false
        })
        .catch(err => {
          this.saving = false
          if (err.response && err.response.status === 403) {
            this.$store.commit("app/message", {
              msg: this.$t("messages.error.permission_denied"),
              color: "error"
            })
          } else {
            let message = ""
            for (const e in err.response.data) {
              message += "- " + e + " : " + err.response.data[e] + "  "
            }
            // this.send(message, "error")
            this.$store.commit("app/message", {
              msg: message,
              color: "error"
            })
          }
        })
    },
    handleSave() {
      if (this.validate()) {
        const p = this.action.id ? this.updateAction() : this.createAction()
        p.then(e => {
          this.$emit("isSaved", true)
        })
      }
    },
    isDisabled() {
      return this.isClosed || this.isSign || !this.action.id
    },
    send(msg, color) {
      this.$store.commit("app/message", { msg, color })
    },
    validate() {
      if (this.action.external_email && this.action.assigned_user) {
        this.send(this.$t("messages.error.only_one_field_required"), "error")
        return false
      }
      return this.$refs.form.validate()
    }
  },
  watch: {
    action: {
      deep: true,
      handler(newValue, oldValue) {
        this.$emit("isSaved", false)
      }
    }
  }
}
</script>
